import { useContext, useState, useEffect } from 'react'
import {MemoryContext} from "../hooks/useSelectMemory";
import {format_number} from "../../../services/vat.services";
import Storage from '../../../services/storage.service';
import {
    fetchZaamInstallmentTimeline,
    isZaamEnabled} from '../../../services/instalments.service';

const useFindInstallmentPrices = (sku = '') => {

    const {selectedMemory} = useContext(MemoryContext) ?? {selectedMemory: null};
    const [subscriptionPrice, setSubscriptionPrice] = useState('');
    const [subscriptionPriceVatExc, setSubscriptionPriceVatExc] = useState('');
    const [installmentsArr, setInstallmentsArr] = useState([]);

    useEffect(()=>{
        if(isZaamEnabled()){
          fetchZaamInstallmentTimeline(sku).then(({data})=>{
            if(data?.zension_timeline){
              setInstallmentsArr(data?.zension_timeline);
              Storage.set("zaam_installment_prices", data?.zension_timeline);
            }
          });
        }
      }, [sku]);

    const setPrices = (priceObj) => {
      let price = format_number(priceObj.SubscriptionPrice);
      let priceVatExc = format_number(priceObj.SubscriptionPriceVatExc);
        setSubscriptionPrice(price);
        setSubscriptionPriceVatExc(priceVatExc);
    }

    useEffect(() => {
        if(selectedMemory && installmentsArr?.length > 0){
            let selectedDeviceSku = selectedMemory?.ExtraDetails?.SKU;
            let installmentForSelectedDevice = installmentsArr.find(item => item.SKU === selectedDeviceSku)
            if(installmentForSelectedDevice){
              setPrices(installmentForSelectedDevice);
            }
        }
    }, [selectedMemory, installmentsArr]);

    useEffect(() => {
        if(sku && installmentsArr?.length > 0){
            let installmentForSelectedDevice = installmentsArr.find(item => item.SKU === sku)
            if(installmentForSelectedDevice){
              setPrices(installmentForSelectedDevice);
            }
        }
    }, [sku, installmentsArr]);

    return {
        subscriptionPrice,
        subscriptionPriceVatExc,
        installmentsArr
    }
}

export default useFindInstallmentPrices;